function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'flock-undyed': 'url("//uplandfiberco.com/cdn/shop/files/Flock_Dollop_120x.jpg?v=16661677551567225800")','cayenne': 'url("//uplandfiberco.com/cdn/shop/files/Cayenne_Dollop_120x.jpg?v=13366500301531309252")','harvest': 'url("//uplandfiberco.com/cdn/shop/files/Harvest_Dollop_120x.jpg?v=2062450907860008149")','medallion': 'url("//uplandfiberco.com/cdn/shop/files/Medallion_Dollop_120x.jpg?v=17160072774726893118")','hunter': 'url("//uplandfiberco.com/cdn/shop/files/Hunter_Dollop_120x.jpg?v=9066296247013519143")','mariner': 'url("//uplandfiberco.com/cdn/shop/files/Mariner_Dollop_120x.jpg?v=7652725412950888726")','storm': 'url("//uplandfiberco.com/cdn/shop/files/Storm_Dollop_120x.jpg?v=11315573680014286351")','steel': 'url("//uplandfiberco.com/cdn/shop/files/Steel_Dollop_120x.jpg?v=6730245058707840752")','pewter': 'url("//uplandfiberco.com/cdn/shop/files/Pewter_Dollop_120x.jpg?v=18207649806077710841")','clay': 'url("//uplandfiberco.com/cdn/shop/files/Clay_Dollop_120x.jpg?v=13854024307832893194")','bubbles': 'url("//uplandfiberco.com/cdn/shop/files/Bubbles_Dollop_120x.jpg?v=6324219914572108041")','glacier': 'url("//uplandfiberco.com/cdn/shop/files/Glacier_Dollop_120x.jpg?v=17366637398075043304")','verdigris': 'url("//uplandfiberco.com/cdn/shop/files/Verdigris_Dollop_120x.jpg?v=16413561197583788038")','saddle': 'url("//uplandfiberco.com/cdn/shop/files/Saddle_Dollop_120x.jpg?v=12802647494882749617")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
